import { Component, OnInit, ViewChild, Output, Input, EventEmitter} from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { GlobalService } from '../global-service.service';
import { MatExpansionPanel} from '@angular/material/expansion';
import { MatTabChangeEvent as MatTabChangeEvent} from '@angular/material/tabs';

import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import * as fileSaver from 'file-saver';

@Component({
    selector: 'app-antraege',
    templateUrl: './antraege.component.html',
    styleUrls: ['../css/pasura.css'],
    standalone: false
})

export class AntraegeComponent implements OnInit {

	@Output("openPolice")   openPoliceEvent:EventEmitter<number> = new EventEmitter<number>();
	@Input() kontakt: any;
	@ViewChild('panSearch',   		 {static: false}) private panSearch: MatExpansionPanel;
	
  	antraege;
  	antrag:any;
  	einschaetzung:any;
  	SuchText="";
  	item=0;
  	Suchoptionen=[true, true, true, false, false];
  	
  	showMailinfo=false;
  	
  	displayedColumns =['Antrag', 'Status','Tierarzt', 'Tierhalter', 'Pferd'];
  	
  	constructor(public globserv: GlobalService, private http:HttpClient, private toastr: ToastrService)
  	{
  	}

  	ngOnInit(): void 
  	{
  		this.globserv.getPasuraAction().subscribe((pasuraAction) => {
      
      console.log("getPasuraAction " + pasuraAction);
      if (typeof pasuraAction === 'string')
      {
        	if(pasuraAction=="resetEditPferd")
	      {
	      	this.globserv.AntragPferd=undefined;
			}
		}
    });

  		if (this.globserv.subsVar==undefined) 
  		{    
	      this.globserv.subsVar = this.globserv.changeKontakt.subscribe((name:string) => {
	      	
	      	console.log(this.kontakt.Bexio.nr);
	      	
	      	if (this.antrag!=undefined)
	      	{
	      	
	      		console.log(this.antrag.Antrag.Tierarzt.Nr);
	      		console.log(this.antrag.Antrag.VN.Nr);
	      		
	      		console.log( Number(this.kontakt.Bexio.nr)==Number(this.antrag.Antrag.VN.Nr));

	      	    
       		 	if(this.kontakt.Bexio.nr==this.antrag.Antrag.Tierarzt.Nr)
       		 	{
       		 		this.setTierarzt();
       		 	}
       		 	
       		 	if( Number(this.kontakt.Bexio.nr)==Number(this.antrag.Antrag.VN.Nr))
       		 	{
       		 		this.setVN();
       		 	}
       		 	
       		 }	   
      	});    
    }  
  	}
  	
  selectAntrag(row)
  {
		this.panSearch.close();
		this.antrag=row;	
		console.log(JSON.stringify(row));
		this.loadEinschaetzung();
				
		if (this.antrag!=undefined && this.antrag.Antrag.VN!=undefined && this.antrag.Antrag.VN.Nr!=undefined)
		{
			this.globserv.setPasuraAction('loadContact;' + this.antrag.Antrag.VN.Nr+ ";Antrag") ;
		}
  }
  
  loadEinschaetzung()
	{
		
		var data={};
		console.log(this.antrag.AntragID);
		var data= {};
  		 
  		var resultData;
  		this.globserv.getBackendData("/v1/getEinschaetzung?nr=" + this.antrag.AntragID, data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  						this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim laden der Einschätzung"}});	 
  					 	console.log("Error");
	  					console.log(err); 					 				
  					 },
  					 
		       () => {
					console.log("einschaetzung " +JSON.stringify(this.einschaetzung));
					this.einschaetzung= resultData.Einschaetzung;
			}
		       
		);
	}

  
  sucheAntraege()
  {
  	
  		this.antraege=undefined;
  		this.antrag=undefined;
  		
		var data={"Suche":this.SuchText, Optionen:this.Suchoptionen};
		var resultData;
		
  		this.globserv.getBackendData("/v1/sucheAntraege",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim suchen der Anträge!"}});	
  					 				console.log("Error");
	  					 			console.log(err);  					 				
  					 		  },
		       () => {
		       	//console.log("Antraege Suchen B");
					this.antraege= resultData.Antraege;
	       		console.log("Antraege " +JSON.stringify(this.antraege));
			}
		);   
	//console.log("Antraege Suchen C");
  }
  
  
  async makeEinschaetzungsAuftragPDF()
  {
		var data= {Antrag:Object.assign({},this.antrag) };
				
		try {
      
      	this.downloadFile(await this.http.post("/api/v1/makeEinschaetzungsAuftragPDF", data, {responseType: 'blob' }).toPromise());
      	this.antrag.AntragStatus=10;	 
			this.antrag.Status='ES. best.';     
      	
  		} catch (e) {
  		
      	console.log(e);
  		}
			
  }
  
  	downloadFile(data) 
	{
        const url = window.URL.createObjectURL(data);
        window.open(url);
  	} 
    
  resetEinschaetzungsAuftragAsk()
  {
		this.toastr.success("",'Auftrag wirklich zurücksetzen ?',
    	{
        closeButton: false,
        enableHtml:false,
        progressBar:true,
        timeOut:6000,
        extendedTimeOut:6000,
       
    	}).onTap.pipe(take(1)).subscribe(() => this.resetEinschaetzungsAuftrag());
	}
	
  resetEinschaetzungsAuftrag()
  {
		
		var data= {Antrag:Object.assign({},this.antrag) };
		 
  		var resultData;
  		this.globserv.getBackendData("/v1/resetEinschaetzungsAuftrag",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim reseten der einschätzung"}});	  
  					 				console.log("Error");
	  					 			console.log(err);					 				
  					 		  },
		       () => {
					this.einschaetzung= resultData.Einschaetzung;
	       		this.antrag.AntragStatus=0;
			}
		       
		);  
	}

   makeEinschaetzungsAuftragMail()
    {
			
		var data= {Antrag:Object.assign({},this.antrag) };
		
  		 
  		var resultData;
  		this.globserv.getBackendData("/v1/makeEinschaetzungsAuftragMail",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler bei der Erstellung des Einschätzungsauftrages per Mail!"}});	  	
  					 				console.log("Error");
	  					 			console.log(err);				 				
  					 		  },
		       () => {
		       	this.einschaetzung= resultData.Einschaetzung;
	       		//console.log("makeEinschaetzungsAuftragMail " +JSON.stringify(this.einschaetzung));
	       		this.showMailinfo=true;
	       		this.antrag.AntragStatus=10;
			}  
		);
	}

  
	getHauptPositionen(p)
	{  
	   var keys = Object.keys(p);
	   var hv=[];
		for(var i=0; i<keys.length; i++)
		{
			var key =keys[i];
			if (p[key].hasOwnProperty('VArt')&& p[key].VArt == 'HV' )
			{
			    	hv.push(p[key]);
			}
		}
		return hv;
	}
	
	setTierarzt()
	{
		
		var data= {"TierarztID":this.kontakt.Bexio.nr,"AntragID": this.antrag.AntragID};
  		var resultData;
  		
  		this.globserv.getBackendData("/v1/setAntragTierarzt",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim setzen des Tierarztes!"}});	  
  					 				console.log("Error");
	  					 			console.log(err);					 				
  					 		  },
		       () => {
		       
					this.antrag= resultData.Antrag;
			}
		       
		);   

	}
	
	setVN()
	{
		var data= {"VN":this.kontakt.Bexio.nr,"AntragID": this.antrag.AntragID};
		var resultData;
  		this.globserv.getBackendData("/v1/setAntragVN",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim setzen des Versicherungsnehmers!"}});	  
  					 				console.log("Error");
	  					 			console.log(err);					 				
  					 		  },
		       () => {
					
					console.log("resultData->" + resultData );
					this.antrag= resultData.Antrag;
			}
		       
		);   
	}
	
	
	
	newVNKontakt()
	{
		var resultData;
		var data= {"VN":this.antrag.Antrag.VN};
		
  		this.globserv.getBackendData("/v1/newVNKontakt",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim erstellen eines neuen Kontaktes für den Versicherungsnehmer!"}});	  
  					 				console.log("Error");
	  					 			console.log(err);					 				
  					 		  },
		       () => {
					
					if(resultData.Status=="OK")
 					{
 						this.antrag.Antrag.VN.Nr=Number(resultData.Nr);
 						this.globserv.setPasuraAction('loadContact;' + resultData.Nr +";noreload");
 						
 					}else{
 					
 						this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim erstellen eines neuen Kontaktes für den Versicherungsnehmer!"}});	 
 					}
			}
		       
		);   
	}
	
	createPolice()
	{
		var myresult;
		var data= {"Antrag":this.antrag.Antrag, "AntragID":this.antrag.AntragID};
		
				
		this.globserv.getBackendData("/v1/createPolice",data).subscribe(
	 
				result => 
  					myresult = result,
  					
  					err => {
  					 				console.log("Error");
  					 				console.log(err);
  					 		  },
    			
    			() => {       		
    						if(myresult.Status=="OK")
    						{
    							console.log("PferdID=" +myresult.PferdID)
    							this.openPoliceEvent.emit(Number(myresult.PolNr));
    						}
    					}
		);
	}

	uebernahmePferd(polNr)
	{
		this.antrag.Antrag.VN.PolNr=polNr;
		var data=this.antrag;
		var resultData;
  		
  		this.globserv.getBackendData("/v1/uebernahmePferd",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler bei der Übernahme des Pferdes!"}});
  					 				console.log("Error");
	  					 			console.log(err);	  					 				
  					 		  },
		       () => {
		       	console.log( JSON.stringify(resultData));
 					if (resultData.Status=='OK')
 					{
 						console.log("openPoliceEvent=" +Number(polNr));
 						this.antrag.AntragStatus = resultData.AntragStatus;
 						this.openPoliceEvent.emit(Number(polNr));
 					
 					}else{
 					
 						this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler bei der Übernahme des Pferdes!"}});
 					}
			}
		);   
	}
	
	deleteAntragAsk()
	{
		this.toastr.success("",'Antrag wirklich löschen?',
    	{
        closeButton: false,
        enableHtml:false,
        progressBar:true,
        timeOut:6000,
        extendedTimeOut:6000,
       
    	}).onTap.pipe(take(1)).subscribe(() => this.deleteAntrag());
	}
	
	ablehnAntragAsk()
	{
		this.toastr.success("",'Antrag wirklich ablehnen?',
    	{
        closeButton: false,
        enableHtml:false,
        progressBar:true,
        timeOut:6000,
        extendedTimeOut:6000,
       
    	}).onTap.pipe(take(1)).subscribe(() => this.ablehnAntrag());
	}
	
	
	deleteAntrag()
	{
		var data= {"AntragID":this.antrag.AntragID};
  		var resultData;
  		
  		this.globserv.getBackendData("/v1/deleteAntrag",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim löschen des Antrags " + this.antrag.AntragID}});
  					 				console.log("Error");
	  					 			console.log(err);	  					 				
  					 		  },
		       () => {
						if(resultData.Status=="OK")
	       			{
	       				this.sucheAntraege();
	       				
	       			}else{
	       			
	       				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim löschen des Antrags " + this.antrag.AntragID}});
	       			}
			}  
		);   
	}
	

	ablehnAntrag()
	{
		var data= {"AntragID":this.antrag.AntragID};
  		var resultData;
  		
  		this.globserv.getBackendData("/v1/ablehnAntrag",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim ablehnen des Antrags " + this.antrag.AntragID}});
  					 				console.log("Error");
	  					 			console.log(err);	  					 				
  					 		  },
		       () => {
						if(resultData.Status=="OK")
	       			{
	       				this.sucheAntraege();
	       				
	       			}else{
	       			
	       				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim ablehnen des Antrags " + this.antrag.AntragID}});
	       			}
			}  
		);   
	}
	

	
	newTierarztKontakt()
	{
		
		var data= {"Tierarzt":this.antrag.Antrag.Tierarzt};
  		var resultData;
  		
  		this.globserv.getBackendData("/v1/newTierarztKontakt",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim erstellen eines neuen Kontaktes für den Tierarzt!"}});	 
  					 				console.log("Error");
	  					 			console.log(err); 					 				
  					 		  },
		       () => {
					if(resultData.Status=="OK")
	       		{
	       			this.antrag.TierarztID=Number(resultData.Nr);
	       			this.antrag.Antrag.Tierarzt.Nr=Number(resultData.Nr);
	       			this.globserv.setPasuraAction('loadContact;' + resultData.Nr);

	       		}else{
	       		
	       			this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim erstellen eines neuen Kontaktes für den Tierarzt!"}});	 			 
	       		}
			}  
		);   
	}
	
	toggelSuchoptionen(idx)
	{
		this.Suchoptionen[idx]=!this.Suchoptionen[idx];			
	}
	
	 getFile(fileID, fileName) 
	 {
	
    this.globserv.runstatus=='running';
    this.downloadFile2(fileID).subscribe(response => {
			let blob:any = new Blob([response], { type: 'text/json; charset=utf-8' });
			const url = window.URL.createObjectURL(blob);
			
			console.log(response);
			this.globserv.runstatus=='';
			fileSaver.saveAs(blob, fileName);
		}), error => console.log('Error downloading the file'),
                 () => console.info('File downloaded successfully');
  }
	
	downloadFile2(fileID):any{	
  			
		return this.http.get("/api/v1/getFile?fileID=" +fileID, {responseType: 'blob'});
  }
  
  editAntrag()
  {
  		console.log(JSON.stringify(this.antrag));
  		
  		var data= Object.assign({},this.antrag.Antrag.Pferd); 
  		data.V_Beginn= this.antrag.Antrag.Praemie.VBeginn;
  		data.VProdukt=this.antrag.Antrag.Praemie.ProduktID;
  		data.Optionen=this.antrag.Antrag.Praemie.Optionen;
  		data.VArt=this.antrag.Antrag.Praemie.SubTarifID;
  		data.VS=this.antrag.Antrag.Praemie.VS;
  		data.Selbstbehalt=this.antrag.Antrag.Praemie.Selbstbehalt;
  		data.GebDat=this.antrag.Antrag.Praemie.GebDat;
  		
  		data.Praemien=this.antrag.Antrag.PraemieCalc.getPraemie;
  		data.Sex= this.antrag.Antrag.Pferd.Sex.substring(0, 1);
  		this.globserv.AntragPferd= data;
  		this.globserv.setPasuraAction('setEditAntragPferd');
  }
  
  saveTierarztPers(id)
  {
  		
  		if (this.kontakt!=undefined && id>0)
  		{
  			console.log("saveTierarztPers to " + id);
  			
  			const result=this.kontakt.Personen.find( pers =>{
				return pers.PersID==id;
			});  	
			
			console.log(result);
			console.log(JSON.stringify(result));
  			this.antrag.Antrag.Tierarzt.Person= result.PersName + " " + result.PersVorname +" (" +  result.PersMail +")";
			this.antrag.Antrag.Tierarzt.EMail = result.PersMail;
			this.antrag.Antrag.Tierarzt.Telefon = result.PersTelefon;			
  			
  		} else {
  			
  			this.antrag.Antrag.Tierarzt.Person="";
  			this.antrag.Antrag.Tierarzt.EMail = this.kontakt.Bexio.mail;
			this.antrag.Antrag.Tierarzt.Telefon = this.kontakt.Bexio.phone_fixed;	
  		} 
  }
}

